import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import CreateUsers from "./CreateUsers";
import AllUsers from "./AllUsers";
import KYCUpdates from "./KYCUpdates";
import DepositRequests from "./DepositManagement";
import WithdrawRequests from "./WithdrawManagement";
import Referral from "./Referral";
import SuperAdminSidebar from "./SuperAdminSidebar";
import "../../styles/styles.css";
import SuperAdminHeader from "./SuperAdminHeader";

const SuperAdminDashboard = () => {
  const [activeTab, setActiveTab] = useState("allusers");
  const [searchQuery, setSearchQuery] = useState("");
  const [refreshKey, setRefreshKey] = useState(0); // State to trigger re-render

  useEffect(() => {
    const interval = setInterval(() => {
      setRefreshKey((prevKey) => prevKey + 1); // Increment the key to trigger re-render
    }, 500000); // Fetch every 5 minutes

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);
  const renderContent = () => {
    switch (activeTab) {
      case "createusers":
        return <CreateUsers searchQuery={searchQuery} />;
      case "allusers":
        return <AllUsers searchQuery={searchQuery} />;
      case "kyc":
        return <KYCUpdates searchQuery={searchQuery} />;
      case "deposit":
        return <DepositRequests searchQuery={searchQuery} />;
      case "withdraw":
        return <WithdrawRequests searchQuery={searchQuery} />;
      case "referral":
        return <Referral searchQuery={searchQuery} />;

      default:
        return <AllUsers searchQuery={searchQuery} />;
    }
  };

  return (
    <>
      <SuperAdminHeader page="dashboard" />
      <SuperAdminSidebar />
      <div className="dashboard">
        <h1> CRM Super Admin Dashboard</h1>
        <div className="tabs">
          <button
            className={activeTab === "createusers" ? "active" : ""}
            onClick={() => setActiveTab("createusers")}>
            Create User
          </button>
          <button
            className={activeTab === "allusers" ? "active" : ""}
            onClick={() => setActiveTab("allusers")}>
            All Users
          </button>
          <button
            className={activeTab === "kyc" ? "active" : ""}
            onClick={() => setActiveTab("kyc")}>
            KYC Updates
          </button>
          <button
            className={activeTab === "deposit" ? "active" : ""}
            onClick={() => setActiveTab("deposit")}>
            Deposit Requests
          </button>
          <button
            className={activeTab === "withdraw" ? "active" : ""}
            onClick={() => setActiveTab("withdraw")}>
            Withdraw Requests
          </button>
          <button
            className={activeTab === "referral" ? "active" : ""}
            onClick={() => setActiveTab("referral")}>
            Referrals
          </button>
        </div>

        {/* Search Bar with Icon */}
        <div className="search-bar">
          <Search className="search-icon" size={20} />
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>

        <div className="content">{renderContent()}</div>
      </div>
    </>
  );
};

export default SuperAdminDashboard;
